import { useState } from "react";
import {
  IBranch,
  IDepartment,
  IManager,
  IShift,
} from "../../workforce/onboarding/assign-roles-responsibility";
import Modal from "../../../common/modal/Modal";
import PersonInfo from "../../../common/person-info";
import { roleNames, statusBgColor } from "../../../../constants/constants";
import { BranchTypeEnum } from "../../../../types/common-types";
import EmptyPlaceholder from "../../../common/empty-paceholder";

interface BranchCardProps {
  branch: IBranch;
}
export default function BranchCard({ branch }: BranchCardProps) {
  return (
    <>
      <div className="content-card">
        {/* Header */}
        <div className="flex items-center justify-between bg-primary px-3 py-2 text-white">
          <div className="flex items-center gap-2">
            <i className="fa-regular fa-building"></i>
            <div className="flex items-center gap-2 ">
              <span
                className={`w-2.5 h-2.5 rounded-full ring-1 ring-gray-200 ${statusBgColor[branch.status]}`}
              ></span>
              <span className="text-sm font-medium">
                {branch?.name}
                {branch.branchType === BranchTypeEnum.HEAD_OFFICE
                  ? " (HO)"
                  : ""}
              </span>
            </div>
          </div>

          <div className="flex px-[5px] py-[3px] min-w-[35px] items-center justify-center bg-white text-[20px] font-medium text-[#505050] shadow">
            {branch.count}
          </div>
        </div>

        <div className="flex flex-col flex-1 justify-between py-1.5 px-2 sm:px-2.5 sm:py-2 gap-1.5 sm:gap-2">
          {/* Address */}
          <div className="">
            <p className="text-[13px] text-[#5c5c5c] line-clamp-2">
              {branch.address}{" "}
              {branch.branchType === BranchTypeEnum.HEAD_OFFICE ? "(HO)" : ""}
            </p>
          </div>

          {/* Shift Card */}
          {branch?.shifts?.length > 0 ? (
            branch?.shifts?.map((shift: IShift, index: number) => (
              <div
                key={index}
                className="overflow-hidden border px-3 py-2 border-gray-300 bg-white"
              >
                {/* Shift Header */}
                <div className="flex items-center justify-between border-b border-gray-200 pb-1.5">
                  <div>
                    <div className="flex items-center gap-2 text-primary">
                      <span
                        className={`w-2.5 h-2.5 rounded-full ring-1 ring-gray-200 ${statusBgColor[shift.status]}`}
                      ></span>
                      <span className="text-sm font-medium">{shift?.name}</span>
                    </div>

                    <p className=" text-xs text-gray-500">
                      {`Time : (${shift.startTime} to ${shift.endTime})`}
                    </p>
                  </div>

                  <span className="text-md font-medium text-gray-700">
                    {shift.count}
                  </span>
                </div>

                {/* Departments */}
                {shift.departments?.length > 0 ? (
                  shift.departments.map((item, index) => (
                    <Department
                      item={item}
                      shift={shift}
                      index={index}
                      key={index}
                    />
                  ))
                ) : (
                  <EmptyPlaceholder
                    title="No Departments found for this shift."
                    description="It seems there is no any department added in this shift. please add department."
                    imageClassName="!w-10 !h-10"
                    className="h-[100px] !gap-1"
                    titleClassName="!text-md"
                    showDescription={false}
                  />
                )}
              </div>
            ))
          ) : (
            <EmptyPlaceholder
              title="No Shifts found for this branch."
              description="It seems there is no any shift added in this branch. please add shift."
              // icon={<Info size={20} />}
              titleClassName="!text-lg"
              className="!py-3 h-[250px]"
              descriptionClassName="!text-xs"
            />
          )}
        </div>
      </div>
    </>
  );
}

const Department = ({
  item,
  shift,
  index,
}: {
  item: IDepartment;
  shift: IShift;
  index: number;
}) => {
  const [employees, setEmployees] = useState<IManager[]>([]);
  return (
    <>
      <div
        key={item.name}
        className={`flex items-center justify-between py-2 ${
          index !== shift.departments.length - 1
            ? "border-b border-gray-200"
            : ""
        }`}
      >
        <div className="flex items-center gap-2 text-[#727272]">
          <span
            className={`w-2.5 h-2.5 rounded-full ring-1 ring-gray-200 ${statusBgColor[item.status]}`}
          ></span>
          <span className="text-sm font-medium">{item?.name}</span>
        </div>

        <span
          className="text-sm font-medium cursor-pointer text-[#727272]"
          onClick={() => setEmployees(item.employee)}
        >
          {item.count}
        </span>
      </div>
      <Modal
        isOpen={employees?.length > 0}
        title={"Employees"}
        onClose={() => setEmployees([])}
        width="max-w-3xl"
        showFooter={false}
      >
        <div className="flex flex-col gap-3">
          <div className="flex justify-center bg-[#dde9f5] p-2">
            <div className="flex items-center gap-2">
              <div className="font-medium">
                {shift.name} | {item.name}
              </div>
              <div className="bg-primary px-3 py-1 text-white font-medium text-center">
                {item.count}
              </div>
            </div>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-4 gap-3">
            {employees?.map((ele: IManager, id: number) => (
              <PersonInfo
                personInfo={{
                  profileImage: ele.profileImage,
                  firstName: ele.firstName,
                  lastName: ele.lastName,
                  description: roleNames[ele.role],
                  status: ele.status,
                }}
                imageClassName="h-[35px] w-[35px]"
                personClassName="text-secondary text-xs truncate w-[110px]"
              />
            ))}
          </div>
        </div>
      </Modal>
    </>
  );
};
